import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/esm/Button';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import checkmark from '../img/google_check_circle.png';
import { useNavigate } from 'react-router-dom';

function SuccessPage() {
  const navigate = useNavigate();

  const handleGoBack = () => {
      navigate("/studentdashboard");
  };

    return (
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Row className="w-100">
          <Col xs={12} md={8} lg={6} className="mx-auto">
          <Card className="text-center shadow-lg">
            <Image src={checkmark} alt="Green Success Checkmark" width={90} className="d-block mx-auto mt-4 mb-2"/>
            <Card.Body>
              <Card.Title>Quiz Sign Up Submitted</Card.Title>
              <Card.Text className="my-3">Your submission was successful. See dashboard for updates!</Card.Text>
              <Button
                variant="primary"
                className="my-3"
                onClick={handleGoBack}
              >
                Go Back to Dashboard
              </Button>
            </Card.Body>
          </Card>
          </Col>
        </Row>
      </Container>
    );
}

export default SuccessPage; 